document.addEventListener('DOMContentLoaded', function () {
  console.log('App loaded');
});

// Import modules
import './accordion.js';
import './navbar.js';
